import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface FloodIrrigationActionEntry {
  actionId: number;
  fillZone: number;
  drainZone: number;
  fillTimeSeconds: number;
  holdTimeSeconds: number;
  drainTimeSeconds: number;
}

export interface ManualFloodIrrigationModalParams {
  eventName: string;
  actions: FloodIrrigationActionEntry[];
}

export interface ManualFloodIrrigationModalResult {
  executed: boolean;
  actions: FloodIrrigationActionEntry[];
}

@Component({
  standalone: false,
  selector: 'app-manual-flood-irrigation-modal',
  templateUrl: './manual-flood-irrigation-modal.component.html',
  styleUrls: ['./manual-flood-irrigation-modal.component.scss']
})

export class ManualFloodIrrigationModalComponent implements OnInit, ManualFloodIrrigationModalParams {
  eventName: string;
  actions: FloodIrrigationActionEntry[] = [];

  modalDragOn: boolean = false;

  result: ManualFloodIrrigationModalResult;

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    this.actions.forEach(a => {
      a.fillTimeSeconds = Math.round(a.fillTimeSeconds / 60) * 60;
      a.holdTimeSeconds = Math.round(a.holdTimeSeconds / 60) * 60;
      a.drainTimeSeconds = Math.round(a.drainTimeSeconds / 60) * 60;
    });
  }

  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      }, 3000);
    }
  }

  incrementFillTime(index: number): void {
    if (this.actions[index].fillTimeSeconds < 10 * 60) {
      this.actions[index].fillTimeSeconds += 60;
    }
  }

  decrementFillTime(index: number): void {
    if (this.actions[index].fillTimeSeconds > 0) {
      this.actions[index].fillTimeSeconds -= 60;
    }
  }

  incrementHoldTime(index: number): void {
    if (this.actions[index].holdTimeSeconds < 60 * 60) {
      this.actions[index].holdTimeSeconds += 60;
    }
  }

  decrementHoldTime(index: number): void {
    if (this.actions[index].holdTimeSeconds > 0) {
      this.actions[index].holdTimeSeconds -= 60;
    }
  }

  incrementDrainTime(index: number): void {
    if (this.actions[index].drainTimeSeconds < 60 * 60) {
      this.actions[index].drainTimeSeconds += 60;
    }
  }

  decrementDrainTime(index: number): void {
    if (this.actions[index].drainTimeSeconds > 0) {
      this.actions[index].drainTimeSeconds -= 60;
    }
  }

  cancel(): void {
    this.result = { executed: false, actions: this.actions };
    this.bsModalRef.hide();
  }

  execute(): void {
    this.result = { executed: true, actions: this.actions };
    this.bsModalRef.hide();
  }
}
